module.exports = __webpack_public_path__ + "static/media/bottom-bars@2x.6a477705.png";